import { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, Alert, Modal, ProgressBar, Card, Nav, Table } from "react-bootstrap";

import _, { setWith } from "lodash";
import axios from "axios";
import moment from "moment";
import Utils from "../../common/Utils";
import { UserContext } from "../../common";

const MyProfile = (props) => {
  const { userData } = useContext(UserContext);
  const [data, setData] = useState({});
  const [udocs, setUDocs] = useState({ doctypes: [], userdocs: [], userdocfiles: [], counts: [], udgs: {} });
  const [loading, setLoading] = useState(true);
  const [dtype, setDType] = useState(0);
  const [resources, setResources] = useState(false);
  const [upload, setUpload] = useState(false);
  const [trail, setTrail] = useState(false);
  const [cal, setCal] = useState(false);
  const [loadres, setLoadres] = useState(false);
  const [showprof, setShowprof] = useState(true);
  const [gapStatus, setGapStatus] = useState(0);
  const [udNote, showUDNote] = useState(false);
  const [notes, setNotes] = useState([]);

  const profileDetails = (status = 0) => {
    setLoading(true);
    status === 0 ? setShowprof(true) : setShowprof(false);
    axios
      .get(Utils.apiUrl("users/fetchprofile") + `?status=${status}&gapStatus=${gapStatus}`, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setData(_.get(res, "data.profile", []));
          setUDocs({
            doctypes: _.get(res, "data.doctypes", []),
            userdocs: _.get(res, "data.userdocs", []),
            userdocfiles: _.get(res, "data.userdocfiles", []),
            counts: _.get(res, "data.counts", []),
            udgs: _.get(res, "data.udgs", []),
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  };

  useEffect(profileDetails, []);

  const fetchUDNotes = () => {
    if (udNote !== false && _.isUndefined(udNote.loading)) {
      showUDNote({ ...udNote, loading: true });
      axios
        .get(Utils.apiUrl(`users/fetchnotes?uid=${userData.uid}&udid=${udNote.id}`), Utils.apiHeaders())
        .then((res) => {
          showUDNote({ ...udNote, loading: false });
          if (res.data.success) {
            setNotes(res.data.data);
          } else {
            window.alert(res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };
  
  useEffect(fetchUDNotes, [udNote]);

  const saveProfile = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    let pvals = {
      firstname: frm.firstname,
      middlename: frm.middlename,
      lastname: frm.lastname,
      phone: frm.phone,
      email: frm.email,
      gdc: frm.gdc,
      doj: frm.doj,
      dob: frm.dob,
      lwd: frm.lwd,
      gender: frm.gender,
      title: frm.title,
      designation: frm.designation,
      pronoun: frm.pronoun,
      notes: frm.notes,
      relship1: frm.relship1,
      name1: frm.name1,
      address1: frm.address1,
      phone1: frm.phone1,
      relship2: frm.relship2,
      name2: frm.name2,
      address2: frm.address2,
      phone2: frm.phone2,
      acnum: frm.acnum,
      ifsc: frm.ifsc,
      bank: frm.bank,
      branch: frm.branch,
    };

    _.each(pvals, validateField);

    let haserror = false;

    //== extra check for date range
    if (pvals.doj.value != "" && pvals.lwd.value != "" && moment(pvals.doj.value).isAfter(moment(pvals.lwd.value))) {
      pvals.lwd.className = "form-control invalid";
      pvals.lwd.focus();
      return false;
    } else {
      pvals.lwd.className = "form-control valid";
    }

    haserror = _.flatten(_.map(pvals, (field) => (field.className.includes("invalid") ? 1 : 0))).includes(1);
    if (haserror) {
      _.each(pvals, (field) => {
        if (field.className.includes("invalid")) {
          field.focus();
          return false;
        } else {
          return true;
        }
      });
      return false;
    }

    _.each(pvals, (v, k) => (pvals[k] = v.value));

    setData(pvals);
    setLoading(true);
    axios
      .post(Utils.apiUrl("users/saveprofile"), Utils.postVars(pvals), Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          //props.onAdd();
          setData(_.get(res, "data.profile", {}));
        } else {
          window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const showStatus = (data) => {
    if (data.exp_status == 0) {
      if (data.doc_status == 1) {
        return <span className="text-success">Approved</span>;
      } else if (data.doc_status == 2) {
        return <span className="text-warning">Pending</span>;
      } else if (data.doc_status == 3) {
        return (
          <span className="text-danger" title={data.msg ?? ""}>
            Disapproved {data.msg && <i class="bi bi-chat-left-dots"></i>}
          </span>
        );
      }
    } else {
      return <span className="text-danger">Expired</span>;
    }
  };

  const uploadFile = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    setLoadres(parseInt(frm.udid.value));

    let formData = new FormData(frm);
    formData.append("time", new moment().format("YYYY-MM-DD HH:mm:ss"));

    axios
      .post(Utils.apiUrl("users/uploadudf"), formData, Utils.apiHeaders())
      .then((res) => {
        setLoadres(false);
        if (res.data.success) {
          setUDocs({ ...udocs, userdocfiles: [...udocs.userdocfiles, res.data.udf] });
          frm.reset();
          // window.alert(res.data.message);
        } else {
          window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const validateMe = (e) => {
    const field = e.currentTarget;
    validateField(field);
  };

  const validateField = (field) => {
    if (field.hasAttribute("regex")) {
      const regex = new RegExp("^" + field.getAttribute("regex") + "$", "i");
      if (regex.test(field.value)) {
        field.className = "form-control valid";
      } else {
        field.className = "form-control invalid";
      }
    }
  };

  const renderForm = () => {
    return (
      <Form className="needs-validation" novalidate onSubmit={saveProfile}>
        <Row>
          <Col sz={2} xl={2} lg={2} md={6} className="mb-1">
            <label className="form-label">Title *</label>
            <select className="form-select" name="title" required defaultValue={_.get(data, "title", "")}>
              {["Mr.", "Mrs.", "Ms.", "Dr.", "Prefer not to say"].map((t) => (
                <option value={t}>{t}</option>
              ))}
            </select>
            <div className="invalid-feedback">Please Select Title of User</div>
          </Col>
          <Col sz={6} xl={4} lg={5} md={6} className="mb-1">
            <label className="form-label">First Name *</label>
            <input
              type="text"
              name="firstname"
              required
              maxlength="30"
              className="form-control"
              placeholder="First name"
              regex="[a-z\s]{1,30}"
              onKeyUp={validateMe}
              defaultValue={_.get(data, "firstname", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={5} md={6} className="mb-1">
            <label className="form-label">Middle Name</label>
            <input
              type="text"
              name="middlename"
              maxlength="30"
              regex="[a-z\s]{0,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Middle name"
              defaultValue={_.get(data, "middlename", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={12} md={6} className="mb-1">
            <label className="form-label">Last Name *</label>
            <input
              type="text"
              name="lastname"
              maxlength="30"
              required
              regex="[a-z\s]{1,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Last name"
              defaultValue={_.get(data, "lastname", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
        </Row>
        <Row>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <label className="form-label">Phone Number *</label>
            <input
              type="phone"
              name="phone"
              required
              maxlength="16"
              regex="[0-9\-]{1,16}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Phone number"
              defaultValue={_.get(data, "phone", "")}
            />
            <small>Please enter a valid phone number upto 16 characters</small>
          </Col>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <label className="form-label">Email ID *</label>
            <input
              type="email"
              name="email"
              required
              maxlength="255"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Email Address"
              defaultValue={_.get(data, "email", "")}
            />
            <small>Please fill a valid Email Address test@test.com format only</small>
          </Col>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <label className="form-label">GDC Number</label>
            <input
              type="text"
              name="gdc"
              regex="[0-9a-zA-Z]*"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="GDC Number"
              defaultValue={_.get(data, "profile.gdc", "")}
            />
            <small>Please enter alpha numberic GDC number!</small>
          </Col>
        </Row>
        <Row>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <div className="ui-front">
              <label for="dob" className="form-label">
                Date of Birth:
              </label>
              <input
                type="date"
                name="dob"
                maxlength="10"
                className="form-control"
                format="dd/mm/yyyy"
                onKeyDown={(e) => e.preventDefault()}
                min="1900-01-01"
                max="2100-12-31"
                defaultValue={_.get(data, "profile.dob", "")}
              />
            </div>
          </Col>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <div className="ui-front">
              <label for="doj" className="form-label">
                Employment Start Date:
              </label>
              <input
                type="date"
                name="doj"
                maxlength="255"
                className="form-control"
                defaultValue={_.get(data, "profile.doj", "")}
                format="dd/mm/yyyy"
                onKeyDown={(e) => e.preventDefault()}
                min="1900-01-01"
                max="2100-12-31"
              />
            </div>
          </Col>
          <Col sz={4} xl={4} lg={4} md={4} className="mb-1">
            <div className="ui-front">
              <label for="lwd" className="form-label">
                Employment Finish Date:
              </label>
              <input
                type="date"
                name="lwd"
                maxlength="255"
                className="form-control"
                defaultValue={_.get(data, "profile.lwd", "")}
                format="dd/mm/yyyy"
                onKeyDown={(e) => e.preventDefault()}
                min="1900-01-01"
                max="2100-12-31"
              />
              <small>Employment Finish Date cannot be before start date</small>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sz={5} xl={5} lg={4} md={4} className="mb-1">
            <label className="form-label">Designation</label>
            <input
              type="text"
              name="designation"
              maxlength="30"
              regex="[a-z\s]{0,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Designation"
              defaultValue={_.get(data, "designation", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={2} xl={2} lg={4} md={4} className="mb-1">
            <label className="form-label">Gender *</label>
            <select className="form-select" name="gender" required defaultValue={_.get(data, "profile.gender", "")}>
              {["Male", "Female", "Transgender", "Others", "Prefer not to say"].map((t) => (
                <option value={t}>{t}</option>
              ))}
            </select>
          </Col>
          <Col sz={5} xl={5} lg={4} md={4} className="mb-1">
            <label className="form-label">Pronouns</label>
            <input
              type="text"
              name="pronoun"
              maxlength="30"
              regex="[a-z\s]{0,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Preferred Pronouns"
              defaultValue={_.get(data, "profile.pronoun", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
        </Row>
        <Row>
          <Col sz={12} xl={12} lg={12} md={12} className="mb-1">
            <label className="form-label">Notes</label>
            <textarea
              name="notes"
              regex="[a-z\s]{0,10000}"
              style={{ height: "80px" }}
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.notes", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
        </Row>

        <h5 className="mt-4">
          <b>1st Emergency Contact</b>
        </h5>

        <Row>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Relationship</label>
            <input
              type="text"
              name="relship1"
              regex="[a-z\s]{0,300}"
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.relship1", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Name</label>
            <input
              type="text"
              name="name1"
              regex="[a-z\s]{0,300}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder=""
              defaultValue={_.get(data, "profile.name1", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Address</label>
            <input type="text" name="address1" className="form-control" defaultValue={_.get(data, "profile.address1", "")} />
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Phone number</label>
            <input
              type="text"
              name="phone1"
              maxlength="16"
              regex="[0-9\-]{0,16}"
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.phone1", "")}
            />
            <small>Please enter a valid phone number upto 16 characters</small>
          </Col>
        </Row>

        <h5 className="mt-4">
          <b>2nd Emergency Contact</b>
        </h5>

        <Row>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Relationship</label>
            <input
              type="text"
              name="relship2"
              regex="[a-z\s]{0,300}"
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.relship2", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Name</label>
            <input
              type="text"
              name="name2"
              maxlength="30"
              regex="[a-z\s]{0,300}"
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.name2", "")}
            />
            <small>only space and alphabetic characters are allowed</small>
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Address</label>
            <input type="text" name="address2" className="form-control" defaultValue={_.get(data, "profile.address2", "")} />
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Phone Number</label>
            <input
              type="text"
              name="phone2"
              maxlength="16"
              regex="[0-9\-]{0,16}"
              onKeyUp={validateMe}
              className="form-control"
              defaultValue={_.get(data, "profile.phone2", "")}
            />
            <small>Please enter a valid phone number upto 16 characters</small>
          </Col>
        </Row>

        <h5 className="mt-4">
          <b>Bank Account Details</b>
        </h5>

        <Row>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">A/C Number</label>
            <input
              type="text"
              name="acnum"
              maxlength="30"
              regex="[0-9a-z]{0,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="A/C Number"
              defaultValue={_.get(data, "profile.acnum", "")}
            />
            <small>Please enter alphanumeric only upto 30 characters.</small>
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">SORT/IFSC Code</label>
            <input
              type="text"
              name="ifsc"
              maxlength="30"
              className="form-control"
              placeholder="SORT/IFSC Code"
              defaultValue={_.get(data, "profile.ifsc", "")}
            />
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Bank Name</label>
            <input
              type="text"
              name="bank"
              maxlength="30"
              className="form-control"
              placeholder="Bank Name"
              defaultValue={_.get(data, "profile.bank", "")}
            />
          </Col>
          <Col sz={6} xl={3} lg={4} md={6} className="mb-1">
            <label className="form-label">Branch</label>
            <input
              type="text"
              name="branch"
              maxlength="30"
              regex="[0-9a-z\s]{0,30}"
              onKeyUp={validateMe}
              className="form-control"
              placeholder="Branch"
              defaultValue={_.get(data, "profile.branch", "")}
            />
            <small>Please enter alphanumeric only upto 30 characters.</small>
          </Col>
        </Row>

        <Row>
          <Col lg={12} className="mb-1">
            <Button type="submit" variant="primary" className="mt-2 p-3">
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    );
  };

  const deleteudf = (udf) => {
    if (window.confirm(`You are going to delete upload file ${udf.udoc}, continue?`)) {
      setLoadres(parseInt(udf.udid));
      axios
        .delete(Utils.apiUrl("users/deleteudf/") + udf.id, Utils.apiHeaders())
        .then((res) => {
          setLoadres(false);
          if (res.data.success) {
            let tmp = [...udocs.userdocfiles];
            _.remove(tmp, (udf1) => parseInt(udf1.id) === parseInt(udf.id));
            setUDocs({ ...udocs, userdocfiles: tmp });
            // window.alert(res.data.message);
          } else {
            window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };
  const getColor = (doc) => {
    const filteredData = udocs.userdocfiles.filter((item) => item.udid === doc.id);
    if (filteredData.length === 0) {
      return "#070d59";
    }
    // Find max id for latest doc
    const maxId = Math.max(...filteredData.map((item) => parseInt(item.id)));
    // Filter data with max id to get last uploaded doc data
    const lastDoc = filteredData.filter((item) => parseInt(item.id) === maxId)[0];
    // console.log(lastDoc);

    // const lastDoc = filteredData[filteredData.length - 1];
    if (lastDoc.exp_status == "1") {
      return "red";
    }
    if (lastDoc.doc_status == "3") {
      return "maroon";
    }
    if (filteredData.some((doc) => doc.doc_status == "2" && doc.exp_status == "0")) {
      return "#FFBF00";
    }
    return "green";
  };

  const showGapStatus = (docid) => {
    //let userDocFiles = _.filter(udocs.userdocfiles, (udf) => parseInt(udf.udid) === parseInt(docid) && moment(udf.expire_on).isAfter(moment()));
    //let gapStatus = _.get(_.maxBy(userDocFiles, 'id'), 'gap_status', 0);
    let gapStatus = _.get(_.find(udocs.udgs, g => g.udid==docid),'gap_status',0);
    const gStatus = Utils.getGapStatusList();

    return <div
      className="rounded text-white p-2 text-center"
      style={{
        width: "150px",
        backgroundColor: gStatus[gapStatus][3]
      }}
    >
      {gStatus[gapStatus][2]}
    </div>
  };

  const renderGapStatusFilters = () => {
    let uds =  udocs.userdocs;
    let udfs = _.filter(udocs.userdocfiles, (udf) => moment(udf.expire_on).isAfter(moment()));
    if(dtype > 0){
      uds = _.filter(uds, (p) => (parseInt(p.cat) === parseInt(dtype)));
      udfs = _.filter(udfs, (udf) => parseInt(udf.udid) === parseInt(dtype));
    }    
    
    return <>
      {_.map(_.slice(Utils.getGapStatusList(),1), (gs) => {
        //udfs = _.filter(udfs, (udf) => parseInt(udf.gap_status)===gs[0]);
        let udgscol = _.filter(udocs.udgs, (udg) => parseInt(udg.gap_status) === parseInt(gs[0]));
        udgscol = _.filter(uds, (ud) => _.includes(_.map(udgscol,u => u.udid),ud.id));
        
        return <Nav.Item className="me-0">
          <Nav.Link style={{backgroundColor: gs[3], 'border-radius': 0}} className="text-white" eventKey={gs[0]}>{udgscol.length}/{uds.length}</Nav.Link>
        </Nav.Item>
      })}
    </>;
  };

  const getFilteredUDocs = () => {
    let uds = _.filter(udocs.userdocs, (p) => (parseInt(p.cat) === parseInt(dtype)) || parseInt(dtype) === 0);
    if(gapStatus > 0){
      uds = _.filter(uds, (ud) => _.includes(_.map(_.filter(udocs.udgs, u => u.gap_status == gapStatus), u => parseInt(u.udid)), parseInt(ud.id)));
    }
    
    return uds;
  }

  const renderDocTypes = () => {
    return (
      <div className="mt-4">
        <div className="d-flex justify-content-between">
          <div className="float-left">
            <Nav variant="pills" className="px-2" activeKey={dtype} onSelect={setDType}>
              <Nav.Item>
                  <Nav.Link eventKey={0}>All</Nav.Link>
                </Nav.Item>
              {_.map(udocs.doctypes, (cat, catidx) => (
                <Nav.Item>
                  <Nav.Link eventKey={catidx}>{cat}</Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
          <div className="float-right">
            <Nav variant="pills" className="px-2" defaultActiveKey={gapStatus} onSelect={setGapStatus}>
              {renderGapStatusFilters()}
            </Nav>
          </div>

        </div>
        <Card style={{ backgroundColor: "#CEDDEF88" }}>
          <Card.Body className="m-2">
            <Table responsive={true}>
              <thead>
                <tr>
                  <th className="text-end" width="50">
                    ##
                  </th>
                  <th>Document Title</th>
                  {parseInt(dtype)===0 && <th>Category</th>}
                  <th>Resources</th>
                  <th>Action</th>
                  <th></th>
                  <th>Gap Analysis</th>
                </tr>
              </thead>
              <tbody>
                {_.map(
                  getFilteredUDocs(),
                  (doc, idx) => {
                    let res = JSON.parse(doc.resources);
                    return (
                      <tr>
                        <td className="text-end">
                          <div className="badge bg-primary text-white">{Utils.addZero(idx + 1)}</div>
                        </td>
                        <td>{doc.title}</td>
                        {parseInt(dtype)===0 && <td>{udocs.doctypes[doc.cat]}</td>}
                        <td>
                          <Button type="button" variant="primary" onClick={() => setResources(res)} disabled={res.length === 0}>
                            View
                          </Button>
                        </td>
                        {/* <td>
                          {loadres === parseInt(doc.id) && <ProgressBar variant="success" animated now={100} className="mt-2" />}
                          {loadres !== parseInt(doc.id) && udfForm(doc.id)}
                        </td> */}
                        <td>
                          <Button
                            className="me-2 ms2"
                            type="button"
                            variant="contained"
                            style={{ backgroundColor: getColor(doc), color: "white" }}
                            onClick={() => setUpload(doc.id)}
                          >
                            {getColor(doc) == "#070d59" ? "Upload" : "Manage"}
                          </Button>
                        </td>
                        <td>
                          <Button className="me-2 ms2 " type="button" variant="primary" onClick={() => setTrail(doc.id)} disabled={res.length === 0}>
                            Trail
                          </Button>
                        </td>
                        <td>
                          {showGapStatus(doc.id)}
                        </td>
                        <td>
                          <img
                            src={`${process.env.PUBLIC_URL}/images/notes.png`}
                            className="clickable"
                            title={`Notes for ${doc.title}`}
                            onClick={() => showUDNote(doc)}
                          />
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </div>
    );
  };

  const showResources = () => {
    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setResources(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Resources</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {_.get(resources.files, "length", 0) > 0 && <h3>Documents</h3>}
          <ol>
            {_.map(resources.files, (r) => (
              <li key={r} className="py-1">
                {/* <a href={Utils.apiUrl("users/downloadud") + "/" + r}> */}
                <a target="_blank" href={Utils.viewerLink(r, `users/downloadud/${r}`)}>
                  {r}
                </a>
              </li>
            ))}
          </ol>
          {_.get(resources.links, "length", 0) > 0 && <h3>Links</h3>}
          <ol>
            {_.map(resources.links, (r) => (
              <li key={r} className="py-1">
                <a href={r} target="_blank">
                  {r}
                </a>
              </li>
            ))}
          </ol>
        </Modal.Body>
      </Modal>
    );
  };

  const showUpload = () => {
    let udf = _.filter(udocs.userdocfiles, (udfs) => parseInt(udfs.udid) === parseInt(upload));
    let ud = _.filter(udocs.userdocs, (uds) => parseInt(uds.id) === parseInt(upload));
    let settings = JSON.parse(ud[0].settings);

    // let expired = moment().isAfter(udf[0].updated_at, "year");

    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setUpload(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{ud[0].title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h3>Documents</h3> */}

          <Table responsive={true}>
            <thead>
              <tr>
                <td>Document Name</td>
                {/* <td>Status</td> */}
                <td>Upload On</td>

                <td>Expire On</td>
                <td>Download</td>
                <td>Delete</td>
              </tr>
            </thead>
            <tbody>
              {_.map(udf, (r) => (
                <tr>
                  <td>{r.udoc}</td>
                  {/* <td>{showStatus(r)}</td> */}
                  <td>{r.created_at}</td>
                  <td>{r.expire_on}</td>
                  <td>
                    <a target="_blank" href={Utils.viewerLink(r.udoc, `users/downloadudf/${r.furl}`)}>
                      <img src="images/download.png" />
                    </a>
                  </td>
                  <td>
                    <Button
                      variant="primary"
                      className="ms-2 clickable"
                      size="xs"
                      title="Delete file"
                      onClick={() => deleteudf(r)}
                      disabled={r.doc_status == 1 || r.exp_status == 1}
                    >
                      X
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Form onSubmit={uploadFile}>
            <input type="hidden" name="udid" value={upload} />
            <div className="row mt-5 d-flex align-items-end">
              <div className="col-md-4">
                <input type="file" required name="udoc" />
              </div>
              {settings.flag == 3 && (
                <div className="col-md-4">
                  Expire Date (Including no expiry date ensures the file will never expire)
                  <input
                    type="date"
                    name="exp_date"
                    maxlength="255"
                    className="form-control"
                    min={new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().split("T")[0]}
                    format="dd/mm/yyyy"
                    onKeyDown={(e) => e.preventDefault()}
                    placeholder="Expire Date"
                  />
                </div>
              )}
              <div className="col-md-3">
                <Button variant="primary" type="submit">
                  Upload
                </Button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  };

  const showTrail = () => {
    let udf = _.filter(udocs.userdocfiles, (udfs) => parseInt(udfs.udid) === parseInt(trail));
    let ud = _.filter(udocs.userdocs, (uds) => parseInt(uds.id) === parseInt(trail));

    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setTrail(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{ud[0].title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h3>Documents</h3> */}
          <Table responsive={true}>
            <thead>
              <tr>
                <td>Name</td>
                <td>Upload On</td>
                <td>Status</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {_.map(udf, (r) => (
                <tr>
                  <td>{r.udoc}</td>
                  <td>{r.updated_at}</td>
                  <td>{showStatus(r)}</td>
                  <td>
                    {/* <a target="_blank" href={Utils.apiUrl("users/downloadudf") + "/" + r.furl}> */}
                    <a target="_blank" href={Utils.viewerLink(r.udoc, `users/downloadudf/${r.furl}`)}>
                      <img src="images/download.png" />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    );
  };

  const docSummery = () => {
    return (
      <Row>
        <Col>
          <Card border="light" className="shadow dashboardStats">
            <Card.Body>
              <Row>
                <Col xs="6" sm="6" md="6" lg="3">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Approved Documents"
                    onClick={() => {
                      profileDetails(1);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "green",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.get(udocs,'counts[0].app_count',0)}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-4 subtitle">Approved</span> <span className="d-block mb-2 subtitle">Documents</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="6" lg="3">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Pending Documents"
                    onClick={() => {
                      profileDetails(2);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      {/* <span className="title me-2" style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '50px',
                        height: '50px',
                        color:'white',
                        backgroundColor: '#ffbf00 ',
                        borderRadius: '8px',
                      }}>
                        {_.get(udocs,'counts[0].pend_count',0)}
                      </span> */}
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#ffbf00 ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.get(udocs,'counts[0].pend_count',0)}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-4 subtitle">Pending</span>
                        <span className="d-block mb-2 subtitle">Documents</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="6" lg="3" mt="5">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Disapproved Documents"
                    onClick={() => {
                      profileDetails(3);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      {/* <span className="title me-2" style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '50px',
                        height: '50px',
                        color:'white',
                        backgroundColor: 'maroon',
                        borderRadius: '8px',
                      }}>
                        {_.get(udocs,'counts[0].disapp_count',0)}
                      </span> */}
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "maroon ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.get(udocs,'counts[0].disapp_count',0)}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-4 subtitle">Disapproved</span>
                        <span className="d-block mb-2 subtitle">Documents</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="6" lg="3">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Expired Documents"
                    onClick={() => {
                      profileDetails(4);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "red ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.get(udocs,'counts[0].expire_count',0)}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-4 subtitle">Expired</span>
                        <span className="d-block mb-2 subtitle">Documents</span>
                      </span>
                    </span>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
  };

  const docGapSummary = () => {
    let total = _.get(udocs.counts,'[0].total',0);
    return (
      <Row className="mt-3">
        <Col>
          <Card border="light" className="shadow dashboardStats">
            <Card.Body>
              <Row>
                <Col xs="6" sm="6" md="4" lg="2">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all documents"
                    onClick={() => {
                      setGapStatus(0);
                      setDType(0);
                      profileDetails(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#070D59",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {total}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">Total</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="4" lg="2">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Have this document"
                    onClick={() => {
                      setGapStatus(1);
                      setDType(0);
                      profileDetails(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#76D773",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.size(_.filter(udocs.udgs, gs => gs.gap_status==1))}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">Have This</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="4" lg="3" mt="5">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Working on it"
                    onClick={() => {
                      setGapStatus(2);
                      setDType(0);
                      profileDetails(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">                     
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#FFBF00 ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.size(_.filter(udocs.udgs, gs => gs.gap_status==2))}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">Working on it</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="4" lg="3">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all Don't Have"
                    onClick={() => {
                      setGapStatus(3);
                      setDType(0);
                      profileDetails(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#EC5353 ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.size(_.filter(udocs.udgs, gs => gs.gap_status==3))}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">Don't Have</span>
                      </span>
                    </span>
                  </div>
                </Col>
                <Col xs="6" sm="6" md="4" lg="2">
                  <div
                    style={{ cursor: "pointer" }}
                    title="View all N/A"
                    onClick={() => {
                      setGapStatus(4);
                      setDType(0);
                      profileDetails(0);
                    }}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <div
                        className="title me-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            minWidth: "50px",
                            height: "50px",
                            backgroundColor: "#848484 ",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            borderRadius: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {_.size(_.filter(udocs.udgs, gs => gs.gap_status==4))}
                        </span>
                      </div>
                      <span>
                        <span className="d-block mb-2 subtitle">N/A</span>
                      </span>
                    </span>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
  };

  const showNotesForUD = () => {
        return (
          <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => showUDNote(false)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">Notes - {udNote.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {udNote.loading === true && (
                <Alert variant="warning" className="p-3">
                  <p className="loading-msg">Fetching User Document Note..</p>
                  <ProgressBar variant="warning" animated now={100} />
                </Alert>
              )}
              {udNote.loading === false && (
                <div style={{ maxHeight: "400px", overflow: "auto" }}>
                  {_.get(notes, "length", 0) === 0 && (
                    <Alert variant="danger" className="p-3">
                      <p className="loading-msg">No notes found!</p>
                    </Alert>
                  )}
                  {_.map(notes, (note) => (
                    <div key={note.id} className="d-flex mt-1 py-2 border-bottom">
                      <div>
                        <div className="badge bg-light text-dark">{Utils.toLocal(note.created_at).format("HH:mm MMM DD, YY")}</div>
                      </div>
                      <div className="text-start text-dark flex-grow-1">{note.note}</div>
                      
                    </div>
                  ))}
                </div>
              )}
            </Modal.Body>
          </Modal>
        );
      };

  return (
    <div className="mt-4">
      {loading && (
        <Alert variant="info" className="p-3">
          <p className="loading-msg">Fetching details..</p>
          <ProgressBar variant="info" animated now={100} />
        </Alert>
      )}
      {!loading && (
        <>
          <h2 className="my-3">
            <b>My Profile</b>
          </h2>
          {docSummery()}
          <Card border="light" className="shadow mt-5 dashboardStats">
            <Card.Body className="mx-3">
              {showprof && (
                <div>
                  <h4 className="mb-3">
                    <b>Personal Details</b>
                  </h4>
                  <Card style={{ backgroundColor: "#CEDDEF88" }}>
                    <Card.Body className="m-2">{renderForm()}</Card.Body>
                  </Card>
                </div>
              )}

              {docGapSummary()}

              {renderDocTypes()}
            </Card.Body>
          </Card>

          {(_.get(resources.files, "length", 0) > 0 || _.get(resources.links, "length", 0) > 0) && showResources()}
          {upload && showUpload()}
          {trail && showTrail()}
          {udNote !== false && showNotesForUD()}
        </>
      )}
    </div>
  );
};

export default MyProfile;
